<template>
  <v-dialog
    v-model="getModalExcluirNCM"
    max-width="500px"
    transition="dialog-transition"
  >
  <v-card>
      <v-card-title>Excluir NCM</v-card-title>
      <v-card-text>
          <h3 align="center">Tem certeza que deseja excluir?</h3>
      </v-card-text>
      <v-card-actions>
          <v-btn color="default" @click="setModalExcluirNCM(false)" outlined>Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="excluirNCM(getNCM)" outlined>Excluir</v-btn>
      </v-card-actions>
  </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters, mapActions} from "vuex"
export default {
    computed: {
        ...mapGetters([
            'getModalExcluirNCM',
            'getNCM'
        ])
    },
    methods: {
        ...mapActions([
            'excluirNCM',
            'setModalExcluirNCM',
        ])
    },
}
</script>